export default [
  'mdiPencil',
  'mdiPencilOutline',
  'mdiSquareEditOutline',
  'mdiTableEdit',
  'mdiAlignHorizontalCenter',
  'mdiAlignHorizontalLeft',
  'mdiAlignHorizontalRight',
  'mdiAlignVerticalBottom',
  'mdiAlignVerticalCenter',
  'mdiAlignVerticalTop',
  'mdiFormatAlignBottom',
  'mdiFormatAlignTop',
  'mdiFormatAlignCenter',
  'mdiFormatAlignJustify',
  'mdiFormatAlignLeft',
  'mdiFormatAlignRight',
  'mdiFormatAlignMiddle',
  'mdiFormatFloatLeft',
  'mdiFormatFloatCenter',
  'mdiFormatFloatRight',
  'mdiFormatFloatNone',
  'mdiFormatListBulleted',
  'mdiFormatListBulletedSquare',
  'mdiFormatListBulletedTriangle',
  'mdiFormatListBulletedType',
  'mdiFormatListCheckbox',
  'mdiFormatListNumbered',
  'mdiFormatListNumberedRtl',
  'mdiFormatListChecks',
  'mdiFormatHorizontalAlignCenter',
  'mdiFormatHorizontalAlignLeft',
  'mdiFormatHorizontalAlignRight',
  'mdiFormatVerticalAlignBottom',
  'mdiFormatVerticalAlignCenter',
  'mdiFormatVerticalAlignTop',
  'mdiBorderAll',
  'mdiBorderBottom',
  'mdiBorderTop',
  'mdiBorderLeft',
  'mdiBorderRight',
  'mdiBorderVertical',
  'mdiBorderHorizontal',
  'mdiBorderInside',
  'mdiBorderOutside',
  'mdiBorderNone',
  'mdiBorderAllVariant',
  'mdiBorderBottomVariant',
  'mdiBorderTopVariant',
  'mdiBorderLeftVariant',
  'mdiBorderRightVariant',
  'mdiBorderNoneVariant',
  'mdiFormatPageBreak',
  'mdiContentCopy',
  'mdiContentPaste',
  'mdiContentCut',
  'mdiDelete',
  'mdiDeleteOutline',
  'mdiTrashCan',
  'mdiTrashCanOutline',
  'mdiFormatLetterCase',
  'mdiFormatLetterCaseUpper',
  'mdiFormatLetterCaseLower',
  'mdiFormatLetterEndsWith',
  'mdiFormatLetterMatches',
  'mdiFormatLetterStartsWith',
  'mdiFormatAnnotationMinus',
  'mdiFormatAnnotationPlus',
  'mdiFormatFont',
  'mdiFormatUnderline',
  'mdiFormatOverline',
  'mdiFormatBold',
  'mdiFormatItalic',
  'mdiFormatText',
  'mdiFormatSize',
  'mdiFormatSection',
  'mdiFormatClear',
  'mdiFormatColorFill',
  'mdiFormatColorText',
  'mdiFormatColorHighlight',
  'mdiSortAscending',
  'mdiSortDescending',
  'mdiFormatStrikethrough',
  'mdiFormatStrikethroughVariant',
  'mdiVectorSquare',
  'mdiFormatTextbox',
  'mdiFormatQuoteClose',
  'mdiRefresh',
  'mdiMagnify',
  'mdiMagnifyPlusOutline',
  'mdiMagnifyMinusOutline',
  'mdiFilter',
  'mdiFilterOutline',
  'mdiPlus',
  'mdiMinus',
  'mdiFormatQuoteOpen',
  'mdiFormatQuoteOpenOutline',
  'mdiFormatQuoteCloseOutline',
  'mdiFormatWrapInline',
  'mdiFormatWrapSquare',
  'mdiFormatWrapTight',
  'mdiFormatWrapTopBottom',
  'mdiCodeParentheses',
  'mdiCodeBrackets',
  'mdiCodeTags',
  'mdiXml',
  'mdiCodeBraces',
  'mdiCodeJson',
];
